import { EntityType } from 'const';
import * as Models from 'models';
import { getValue } from 'utils/getter';

export function isProjectFile(document: Models.CombinedDocument): document is Models.ProjectFile;
export function isProjectFile(document: Models.CombinedDocumentMap): document is Models.ProjectFileMap;
export function isProjectFile(document): boolean {
  return getValue(document, 'entityType') === EntityType.PROJECT_FILE;
}
